import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxAccordionModule, DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDateBoxModule, DxDropDownBoxModule, DxFileUploaderModule, DxGalleryModule, DxListModule, DxNumberBoxModule, DxPopupModule, DxRadioGroupModule, DxScrollViewModule, DxSelectBoxModule, DxTabPanelModule, DxTagBoxModule, DxTextAreaModule, DxTextBoxModule, DxTileViewModule, DxTreeListModule, DxTreeViewModule } from 'devextreme-angular';
import { ImportFromLibraryComponent } from './import-from-library.component';
// import { dinamicProgrammerModule } from '../../engineering/dinamicProgrammer/dinamicProgrammer.module';



@NgModule({
  declarations: [ImportFromLibraryComponent],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxAutocompleteModule,
    DxPopupModule,
    DxButtonModule,
    DxTextBoxModule,
    DxNumberBoxModule,
    DxDataGridModule,
    DxDateBoxModule,
    DxGalleryModule,
    DxTileViewModule,
    DxCheckBoxModule,
    DxButtonModule,
    DxTagBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxRadioGroupModule,
    DxTreeListModule,
    DxTabPanelModule,
    DxAccordionModule,
    DxTextAreaModule,
    DxFileUploaderModule,
    DxListModule,
    // dinamicProgrammerModule
  ],
  exports: [
    ImportFromLibraryComponent
  ]
})
export class ImportLibraryDinamicModule { }
